<template>
  <div v-if="memo.indexID == '1010001'">
    <van-dialog
      v-model="IsShowPage"
      title="地标信息"
      :show-confirm-button="false"
      :show-cancel-button="true"
      @cancel="getBack"
    >
      <van-cell title="ModelName" :value="memo.ModelName" :border="false" />
        <van-cell title="indexId" :value="memo.indexId" :border="false" />
        <van-cell title="newuid" :value="memo.newuid" :border="false" />
        <van-cell title="olduid" :value="memo.olduid" :border="false" />
        <van-cell title="paynum" :value="memo.paynum" :border="false" />
    </van-dialog>
  </div>
  <div v-else-if="memo.indexID == '1010002'" >
    <van-dialog
      v-model="IsShowPage"
      title="地标信息"
      :show-confirm-button="false"
      :show-cancel-button="true"
      @cancel="getBack"
    >
       <van-cell title="indexID" :value="memo.indexID" :border="false" />
        <van-cell title="fileID" :value="memo.fileID" :border="false" />
        <van-cell title="userID" :value="memo.userID" :border="false" />
        <van-cell title="modelName" :value="memo.modelName" :border="false" />
        <van-cell title="modelAllPrice" :value="memo.modelAllPrice" :border="false" />

          <van-cell title="modelPrice" :value="memo.modelPrice" :border="false" />
        <van-cell title="modelHash" :value="memo.modelHash" :border="false" />
        <van-cell title="isAsset" :value="memo.isAsset" :border="false" />
        <van-cell title="assetHash" :value="memo.assetHash" :border="false" />
        <van-cell title="tx_state" :value="memo.tx_state" :border="false" />

         <van-cell title="tx_type" :value="memo.tx_type" :border="false" />
        <van-cell title="x" :value="memo.x" :border="false" />
        <van-cell title="y" :value="memo.y" :border="false" />
        <van-cell title="z" :value="memo.z" :border="false" />
    </van-dialog>
  </div>
</template>

<script>
export default {
  props: ['isVisible','memo'],
  data() {
    return {
      IsShow:true,
      // 定义一个IsShowPage来接收传递过来的值
      IsShowPage: this.isVisible,
    };
  },
  watch: {
    isVisible(val) {
      this.IsShowPage = val; // 新增isVisible的watch，监听变更并同步到IsShowPage上
    },
  },
  mounted(){
    console.log(this.memo);
  },
  methods: {
    getBack(){
         this.$parent.show = false
    }
    
  },
 
};
</script>
<style lang="scss" scoped>
.van-dialog {
    max-height: 80vh;
    overflow: auto;
    top: 50%;
}
</style>
